import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { BucketLogData } from '@bucketplace/bucket-log';

import { BadgeType } from '../ExhibitionProductCard/TextBadge/types';
import { CarouselList } from './CarouselList';
import { OneColList } from './OneColList';
import { ThreeColList } from './ThreeColList';
import { TwoColList } from './TwoColList';
import { ColType, ExhibitionItem } from './types';

export interface ExhibitionsProps {
  disableVerticalPadding?: boolean;
  storeItemList: ExhibitionItem[];
  colType: ColType;
  badgeType: 'none' | BadgeType;
  useBuyButton?: boolean;
  logData?: BucketLogData;
  experimentType?: string;
}

export function Exhibitions({
  colType,
  ...others
}: ExhibitionsProps) {
  const renderList = (): ReactElement => {
    switch (colType) {
      case 1:
        return <OneColList {...others} />;
      case 2:
        return <TwoColList {...others} />;
      case 3:
        return <ThreeColList {...others} />;
      case 'carousel':
        return <CarouselList {...others} />;
      default:
        return <OneColList {...others} />;
    }
  };

  return (
    <Wrapper>
      { renderList() }
    </Wrapper>
  );
}

const Wrapper = styled.div``;
